








































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {traineeStatisticsClient} from "@/api/clients.context";
import {TraineeMathAggregatedStatistic} from "@/api/api.clients";

@Component({
    components: {}
})

export default class traineeMathSingleTimestableStatistics extends Vue {
    @Prop(String)
    traineeId: string = '';

    @Prop(Number)
    table: number = 0;

    private busy:boolean=false;
    private statistic :TraineeMathAggregatedStatistic|null=null;

    @Watch('traineeId')
    @Watch('table')
    async onPropertyChanged(value: string, oldValue: string) {
        if(this.traineeId.length>0 && this.table>0)            {
            this.busy=true;
            this.statistic = await traineeStatisticsClient.getMultiplicationTasksStatisticForTable(this.traineeId,this.table);
            this.busy=false;
        }
    }
}
